/*
 *
 * CandidateProfileComponent constants
 *
 */
import structuredInterviewingIcon from "resources/images/structured_interviewing-banner-icon.svg";
import developIcon from "resources/images/develop-candidate-report-merchandising.svg";

/*
 * NO NEED TO ADD THE SUBTESTID MANUALLY!
 * Run `npm run generate` and select `newSubTest` to automate the adding new subTestId process
 * The script will automatically add the new subTestId to all the mappings being used in the repo
 * For more instructions: https://criteria.atlassian.net/wiki/spaces/FRO/pages/1562017793/Adding+SubTestIds+of+New+Assessments+in+Platform#MUST-READ%3A-Automating-the-Adding-SubTestId-Process-with-the-Plop-Generator
 */
export const subTestIdToSubTestName = {
  1: "CCAT",
  2: "CCAT",
  3: "CCAT",
  4: "CBST",
  5: "CBST",
  6: "CBST",
  7: "CPI",
  8: "BMST",
  9: "BVST",
  10: "MRAB",
  11: "MRAB",
  12: "MRABe",
  13: "CAST",
  14: "Memory",
  15: "Selective Attention",
  16: "Mental Rotation",
  17: "Divided Attention",
  18: "CASTe",
  19: "CSAP",
  20: "SalesAP",
  21: "WTMA",
  22: "WTMAes-la",
  23: "TT",
  24: "TKT",
  25: "Excel 03",
  26: "Word 03",
  27: "Excel 07",
  28: "Word 07",
  29: "CCAT",
  30: "EPP",
  31: "CCAT",
  32: "CBST",
  33: "CCAT",
  34: "CLIK",
  35: "WPP",
  36: "CCAT",
  37: "CCAT",
  38: "CCAT",
  39: "CBSTe",
  40: "CCAT",
  41: "Excel 10",
  42: "Word 10",
  43: "EPP",
  44: "CCAT Rx",
  45: "CCAT UK2",
  46: "CCAT",
  47: "CCAT",
  48: "CCAT",
  49: "CCAT",
  50: "CCAT",
  51: "CCAT",
  52: "WPPe",
  53: "CCAT",
  54: "CCAT",
  55: "CBST CA",
  56: "CCAT CA",
  57: "CCAT",
  58: "Excel 13",
  59: "Word 13",
  60: "CCAT",
  61: "CCAT",
  62: "CCAT",
  63: "CBST",
  64: "CBST",
  65: "CBST Rx",
  66: "AIT",
  67: "UCAT",
  68: "UCATe",
  69: "UCATf",
  70: "CBST EU",
  71: "CCAT UK2 RX",
  72: "PPT 13",
  73: "UCATc",
  74: "UCATj",
  75: "UCATh",
  76: "Excel 16",
  77: "Word 16",
  78: "PPT 16",
  79: "UCATg",
  80: "CBST",
  81: "CBST",
  82: "CBST",
  83: "CBST",
  84: "UCAT Rx",
  85: "UCATpl",
  86: "UCATpg",
  87: "UCATb",
  88: "EPP ES-ES",
  89: "EPPf",
  90: "EPPp",
  91: "EPPc",
  92: "GAME",
  95: "CMRA",
  96: "UCATsv",
  97: "UCATm",
  98: "EPPu",
  99: "EPPg",
  100: "WTMA Rx",
  101: "CCAT",
  102: "CMRAs",
  103: "CMRAf",
  104: "UCATcs",
  105: "UCATnl",
  106: "UCATu",
  109: "Emotify",
  110: "Cognify",
  111: "CBST Rx",
  112: "Emotify Rx",
  131: "CCAT cAT",
  132: "Illustrait",
  118: "UCATk",
  133: "UCATc",
  134: "UCATpg",
  135: "CLIK",
  137: "Emotify",
  138: "UCognify",
  139: "UCognify",
  140: "UCognify de",
  141: "UCognify es-es",
  142: "UCATi",
  143: "UCognify pt-br",
  144: "UCognify pt-br",
  145: "UCognify fr-ca",
  146: "UCognify fr-ca",
  150: "UCognify pt-pt",
  151: "UCognify pt-pt",
  152: "EPP ES-LA",
  153: "UCognify es-la",
  154: "UCognify es-la",
  156: "EPP ZH-CN",
  157: "EPP JA",
  155: "EPP PT-BR",
  158: "UCognify de",
  159: "UCognify ko",
  160: "UCognify ko",
  161: "UCognify tr",
  162: "UCognify tr",
  163: "Cognify tr",
  164: "Cognify tr",
  165: "GAMEes-la",
  166: "UCognify fr-fr",
  167: "UCognify fr-fr",
  168: "UCognify es-es",
  169: "UCognify ja",
  170: "UCognify ja",
  171: "WSPes-la",
  172: "WSP L es-la",
  173: "UCognify zh-cn",
  174: "UCognify zh-cn",
  175: "WSPpt-br",
  176: "WSP L pt-br",
  177: "UCATfr-ca",
  178: "UCATes-la",
  179: "Excel 365",
  180: "Excel 365",
  181: "Word 365",
  182: "PowerPoint 365",
  183: "UCognify it",
  184: "UCognify it",
  185: "EPPit",
  186: "EPPfr-fr",
  187: "WTMAfr-ca",
  190: "CLPT-EN",
  191: "CLPTE-EN",
  192: "CLPT-EN es-es",
  193: "CLPT-EN es-la",
  194: "CLPT-EN fr-fr",
  195: "CLPT-EN fr-ca",
  196: "CLPT-EN pt-pt",
  197: "CLPT-EN pt-br",
  198: "CLPT-EN zh-cn",
  199: "CLPT-EN de",
  200: "CLPT-EN it",
  201: "CLPT-EN ja",
  202: "CLPT-EN ko",
  203: "CLPT-EN tr",
  204: "CLPTE-EN es-es",
  205: "CLPTE-EN es-la",
  206: "CLPTE-EN fr-fr",
  207: "CLPTE-EN fr-ca",
  208: "CLPTE-EN pt-pt",
  209: "CLPTE-EN pt-br",
  210: "CLPTE-EN zh-cn",
  211: "CLPTE-EN de",
  212: "CLPTE-EN it",
  213: "CLPTE-EN ja",
  214: "CLPTE-EN ko",
  215: "CLPTE-EN tr",
  216: "EPPnl",
  217: "EPPpl",
  218: "EPPro",
  219: "EPPcs",
  220: "EPPda",
  221: "EPPsv",
  222: "UCATda",
  223: "UCATro",
  224: "WPPpt-br",
  225: "WTMAfr-fr",
  226: "WTMAes-es",
  227: "WTMAuk",
  228: "EPPuk",
  229: "WSPfr-ca",
  230: "WSP L fr-ca",
  231: "WTMAde",
  232: "WTMApl",
  233: "EPPsk",
  234: "WTMAit",
  235: "WTMAcs",
  236: "WTMAsk",
  237: "GAMEfr-ca",
  238: "EPPar",
  240: "CTRSE",
  241: "CTRSE es-la",
  242: "CTRSE fr-ca",
  243: "CTRSE pt-br",
  // LAST LINE - DO NOT MOVE THIS COMMENT
};

export const CANDIDATE_REPORT_MERCHANDISING_BANNER_DATA = {
  EPP: {
    develop: {
      title: "Develop",
      iconImg: developIcon,
      getStartedDescription:
        "Develop helps your teams and managers unlock employee growth with the same science-backed approach as our hiring tools—all powered by our AI chatbot, Coach Bo. Identify strengths, uncover opportunities, and drive success at every stage.",
      learnMoreDescription:
        "Love discovering candidates' versatility? With Develop, dive deeper into team dynamics, measure sentiment, and build a high-performing team—all with our science-backed approach.",
      eventName: "develop_modal",
      surfaceArea: "epp_talent_mobility",
      fallbackUrl: "https://www.criteriacorp.com/develop",
    },
    structuredInterviewing: {
      title: "Structured Interviewing",
      iconImg: structuredInterviewingIcon,
      getStartedDescription:
        "Maximize the impact of your EPP-recommended interview questions! Use them in our interviewing solutions to speed up hiring—3x faster than phone screens and 2x more predictive of success. Try it today!",
      learnMoreDescription:
        "Loved the interview questions recommended by the EPP? Take them to the next level with our interviewing solutions—3x faster than phone screens and 2x more predictive of success.",
      eventName: "si_modal",
      surfaceArea: "epp_interview_questions",
      fallbackUrl: "https://www.criteriacorp.com/interview",
    },
  },
  WIR: {
    develop: {
      title: "Develop",
      iconImg: developIcon,
      getStartedDescription:
        "Love discovering candidates' versatility? Use Develop and get the same powerful insights for your employees and teams— dive into team dynamics, identify strengths, and build a high-performing team with our science-backed approach.",
      learnMoreDescription:
        "Love discovering candidates' versatility? Get Develop to unlock the same powerful insights for your employees and teams— dive into team dynamics, identify strengths, and build a high-performing team with our science-backed approach.",
      eventName: "develop_modal",
      surfaceArea: "wir_interview_questions",
      fallbackUrl: "https://www.criteriacorp.com/develop",
    },
  },
  Summary: {
    structuredInterviewing: {
      title: "Structured Interviewing",
      iconImg: structuredInterviewingIcon,
      learnMoreDescription:
        "Accelerate your hiring process with interviewing tools that are 3x faster than phone screens, 2x more predictive of success, and loved by 70% of candidates.",
      eventName: "si_modal",
      surfaceArea: "summary_candidate_profile",
      fallbackUrl: "https://www.criteriacorp.com/interview",
    },
  },
  "Manager Guide": {
    develop: {
      title: "Develop",
      iconImg: developIcon,
      getStartedDescription:
        "Love learning how to manage a potential new employee? Use Develop to unlock the same powerful insights for your whole team— dive into team dynamics, identify strengths, and build a high-performing team with our science-backed approach.",
      surfaceArea: "manager_guide",
      fallbackUrl: "https://www.criteriacorp.com/develop",
    },
  },
};
